var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditFormatQuote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -960 960 960",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M687-280q-30 0-46-25.5t-2-52.5l41-82h-80q-33 0-56.5-23.5T520-520v-120q0-33 23.5-56.5T600-720h120q33 0 56.5 23.5T800-640v181q0 9-1.5 18.5T792-423l-57 113q-7 14-20 22t-28 8Zm-360 0q-30 0-46-25.5t-2-52.5l41-82h-80q-33 0-56.5-23.5T160-520v-120q0-33 23.5-56.5T240-720h120q33 0 56.5 23.5T440-640v181q0 9-1.5 18.5T432-423l-57 113q-7 14-20 22t-28 8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditFormatQuote);
export default __webpack_public_path__ + "static/media/edit-format-quote.d62e454dbcab76e7262e07743ed9512a.svg";
export { ForwardRef as ReactComponent };